export default {
    "masterData": {
        // credit term
        "1day": "1 Day",
        "3day": "3 Days",
        "15day": "15 Days",
        "30day": "30 Days",
        "45day": "45 Days",
        "60day": "60 Days",
        "90day": "90 Days",
        "120day": "120 Days",
        // payment type
        "cheque": "Cheque",
        "cash": "Cash",
        "bankTransfer": "Bank Transfer",
        "postpaid": "Postpaid (30 days)",
        "company": "Company",
        "individual": "Individual",
    }
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/masterData/index.js